<template>
  <div>
    <ui-spinner v-if="loading.view == true"></ui-spinner>
    <div v-else>
      <div class="row form-row">
        <div class="col-lg-3">
          <div class="form-group">
            <label for="" class="form-label">Nombre *</label>
            <input
                v-model="name"
                type="text"
                class="form-control form-control-sm"
            />
          </div>
          <div class="form-group">
            <label for="" class="form-label">Abreviatura *</label>
            <input
                v-model="abbreviation"
                type="text"
                class="form-control form-control-sm"
            />
          </div>
          <div class="form-group text-right">
            <button
                class="btn btn-sm btn-outline-success"
                :disabled="loading.crud"
                @click="onNew"
            >
              Nuevo
            </button>
            <button
                class="ml-2 btn btn-sm btn-primary"
                :disabled="loading.crud"
                @click="onSave"
            >
              Guardar
            </button>
          </div>
        </div>
        <div class="col-lg-9">
          <div class="table-responsive">
            <table class="table table-bordered table-sm table-hover">
              <thead class="table-secondary">
              <tr class="text-center align-middle">
                <th style="width: 100px"></th>
                <th>Nombre</th>
                <th>Abreviatura</th>
                <th>UC</th>
                <th>UM</th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="item in containers.trenes"
                  :key="item.idTrenServicio"
                  class="align-middle text-center"
              >
                <td>
                  <template v-if="item.origen != 0">
                    <button
                        class="btn btn-xs btn-icon btn-light-warning"
                        @click="onEdit(item)"
                    >
                      <span class="fa fa-fw fa-pencil-alt"></span>
                    </button>
                    <button
                        class="btn btn-xs btn-icon btn-light-danger ml-2"
                        @click="onDelete(item)"
                    >
                      <span class="fa fa-fw fa-trash-alt"></span>
                    </button>
                  </template>
                  <button
                      @click="onShowModalTrenNumeros(item)"
                      class="btn btn-xs btn-icon btn-light-primary ml-1"
                  >
                    <span class="fa fa-fw fa-list"></span>
                  </button>
                </td>
                <td>{{ item.nombre }}</td>
                <td>{{ item.abreviatura || "" }}</td>
                <td>{{ item.usuarioCreador }}</td>
                <td>{{ item.usuarioModif }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <ModalTrenNumeros
        v-if="containers.showModalTrenNumeros"
        :tren="containers.tren"
        :show="containers.showModalTrenNumeros"
        @close="containers.showModalTrenNumeros = false"
    />
  </div>
</template>
<script>
import ModalTrenNumeros from "@/modals/TrenNumeros.vue";
export default {
  components: {
    ModalTrenNumeros,
  },
  data() {
    return {
      name: "",
      abbreviation: "",
      credito: false,
      loading: {
        view: true,
        crud: false,
      },
      containers: {
        id: null,
        trenes: [],
        tren: null,
        showModalTrenNumeros: false,
      },
    };
  },
  async created() {
    const vm = this;

    let {
      data: { content },
    } = await vm.axios.get("/mantenimiento/trenes");

    vm.containers.trenes = content.trenes;

    vm.loading.view = false;
  },
  methods: {
    onSave() {
      let vm = this;
      let fd = {
        name: String(vm.name).trim(),
        abbreviation: String(vm.abbreviation).trim(),
        credito: vm.credito ? 1 : 0,
        _method: "POST",
      };

      if (!(fd.name && fd.abbreviation)) {
        return vm.$swal.fire(
            "",
            "Completa los campos obligatorios (*)",
            "warning"
        );
      }

      vm.loading.crud = true;

      let endpoint = "/mantenimiento/trenes";

      if (vm.containers.id) {
        endpoint = `/mantenimiento/trenes/${vm.containers.id}`;
        fd._method = "PUT";
      }

      vm.axios
          .post(endpoint, fd)
          .then((response) => {
            if (vm.containers.id) {
              let findRow = vm.containers.trenes.find(
                  (item) => item.idTrenServicio == vm.containers.id
              );

              findRow.nombre = fd.name;
              findRow.abreviatura = fd.abbreviation;
              findRow.usuarioModif = vm.$store.state.user.codigo;
            } else {
              vm.containers.trenes.push({
                nombre: fd.name,
                abreviatura: fd.abbreviation,
                idTrenServicio: response.data.content.id,
                usuarioCreador: vm.$store.state.user.codigo,
              });

              vm.containers.id = response.data.content.id;
            }

            vm.$toast.fire(response.data.message, "", "success");
          })
          .catch((error) => {
            vm.$toast.fire(error.response.data.message, "", "error");
          })
          .finally(() => {
            vm.loading.crud = false;
          });
    },
    onEdit(pItem) {
      let vm = this;
      vm.containers.id = pItem.idTrenServicio;
      vm.name = pItem.nombre;
      vm.abbreviation = pItem.abreviatura;
    },
    async onDelete(pItem) {
      let vm = this;
      let response = await vm.$confirm.fire(
          "",
          "¿Seguro que desea eliminar este item?"
      );

      if (response.value) {
        vm.loading.crud = true;

        vm.axios
            .delete(`/mantenimiento/trenes/${pItem.idTrenServicio}`)
            .then((response) => {
              let tempRegistros = [...vm.containers.trenes];
              vm.containers.trenes = tempRegistros.filter(
                  (item) => item.idTrenServicio != pItem.idTrenServicio
              );
            })
            .catch((error) => {
              vm.$toast.fire(error.response.data.message, "", "error");
            })
            .finally(() => {
              vm.loading.crud = false;
            });
      }
    },
    onNew() {
      let vm = this;
      vm.containers.id = null;
      vm.name = "";
    },
    onShowModalTrenNumeros(pItem) {
      this.containers.tren = pItem;
      this.containers.showModalTrenNumeros = true;
    },
  },
};
</script>
